import { render, staticRenderFns } from "./shopping-cart-product-confirmation-modal.vue?vue&type=template&id=04404d4e&scoped=true&"
import script from "./shopping-cart-product-confirmation-modal.vue?vue&type=script&lang=ts&"
export * from "./shopping-cart-product-confirmation-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04404d4e",
  null
  
)

export default component.exports